import { render, staticRenderFns } from "./FormPressNotesPg.vue?vue&type=template&id=62adbe66&scoped=true&"
import script from "./FormPressNotesPg.vue?vue&type=script&lang=js&"
export * from "./FormPressNotesPg.vue?vue&type=script&lang=js&"
import style0 from "./FormPressNotesPg.vue?vue&type=style&index=0&id=62adbe66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62adbe66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VRow,VTextField})
